<template>
  <div class="purchase-history">
    <div class="templat-list">
      <div class="search-form">
        <el-form size="small" v-model="searchForm">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item prop="searchDates">
                <el-date-picker
                  v-model="searchForm.searchDates"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button type="primary" @click="searchFun">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="table" width="100%" :data="tableList" border stripe size="small" :max-height="newTableHeight">
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="订单号" prop="orderNo"></el-table-column>
          <el-table-column label="购买时间" prop="txnTime"></el-table-column>
          <el-table-column label="购买短信条数" prop="number"></el-table-column>
          <el-table-column label="购买金额（元）" prop="amount"></el-table-column>
          <el-table-column label="充值状态" prop="payStatus">
            <template slot-scope="{ row }">
              <span>{{statusList[row.payStatus]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.size"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@/constants'
import debounce from 'lodash/debounce'
export default {
  name: 'PurchaseHistory',
  data() {
    return {
      searchForm: {
        searchDates: []
      },
      tableList: [],
      page: {
        size: 20,
        current: 1,
        total: 0
      },
      // 状态枚举
      statusList: {
        10: '待支付',
        15: '二维码成功',
        18: '扫码成功',
        20: '支付成功',
        50: '支付失败'
      },
      newTableHeight: 0,
      tableWidth: 0,
      searchDates: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      this.tableWidth = '100%'
    })
    this.searchFun(1)
    this.$nextTick(() => {
      setTimeout(() => {
        this.setTableHeight()
        this.tableWidth = '100%'
        // 绑定窗口resize事件 计算table高度
        this.resizeCallback = debounce(this.setTableHeight, 500)
        window.addEventListener('resize', this.resizeCallback, false)
      }, 300)
    })
  },
  methods: {
    dayjs(value) {
      if (value) {
        const date = new Date(value)
        const yyyy = date.getFullYear()
        const MM = date.getMonth() + 1
        const DD = date.getDate()
        return `${yyyy}-${MM > 9 ? MM : '0' + MM}-${DD > 9 ? DD : '0' + DD}`
      }
      return ''
    },
    getClientHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    setTableHeight() {
      const table = this.$refs.table
      if (table) {
        const clientHeight = this.getClientHeight()
        this.newTableHeight = clientHeight - 320
      }
    },
    async searchFun(val) {
      if (val) {
        this.page.current = 1
      }
      const [ startTime = '', endTime = '' ] = this.searchForm.searchDates
      const params = {
        ...this.page,
        startTime: this.dayjs(startTime) ? this.dayjs(startTime) + ' 00:00:00' : '',
        endTime: this.dayjs(endTime) ? this.dayjs(endTime) + ' 23:59:59' : ''
      }
      const { data, msg, code } = await this.$API.qrPage(params)
      if (code === RESPONSE_SUCCESS) {
        const { records, total, size, current } = data
        this.tableList = records
        this.page.total = total
        this.page.size = size
        this.page.current = current
      } else {
        this.$message.warning(msg)
      }
    },
    handleSizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.searchFun()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input {
  width: 100% !important;
}
.add-button ::v-deep .el-form-item__content {
  text-align: right !important;
}
.table{
  height: calc(100vh - 320px);
}
.page{
  margin-top: 20px;
  text-align: right;
  ::v-deep .el-pagination__editor.el-input {
    width: 50px;
  }
  ::v-deep .el-pagination .el-select .el-input {
    width: 100px;
  }
}
.point::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 6px;
  display: inline-block;
  margin-right: 6px;
}
.warning::after {
  background: #E6A23C;
}
.danger::after {
  background: #F56C6C;
}
.success::after {
  background: #67C23A;
}
</style>
